import { Channel } from "@/models/channel";
import { Pagination } from "@/models/pagination";
import { IChannel, ChannelState } from "@/types/channel";
import { GeneralMutationTree } from "../generalMutation";

const mutations: GeneralMutationTree<ChannelState, IChannel> = {
  single: (state, single) => {
    state.single = new Channel(single);
  },
  pagination: (state, pagination) => {
    pagination.data = pagination.data.map((item) => new Channel(item));
    state.pagination = new Pagination(pagination);
  },
  clear: (state) => {
    state.single = new Channel();
    state.pagination = new Pagination();
  },
};

export default mutations;
